import PagaEnCuotas from './PagaEnCuotas';
export default PagaEnCuotas;
